import { LinearProgress } from "@mui/material";
import styles from "./Spinner.module.scss";

const Spinner = ({ loading }: any) => {
  return (
    <>
      {loading && (
        <div className={styles.loadingWrapper}>
          <LinearProgress
            sx={{
              width: "100vw",
              height: "4px",
              backgroundColor: "rgba(0, 0, 0, 0.1)",
              "& .MuiLinearProgress-bar": {
                backgroundImage: "linear-gradient(to right, #000000, #888888)",
              },
            }}
            color="inherit"
          />
        </div>
      )}
    </>
  );
};

export default Spinner;
